import { createFileRoute } from '@tanstack/react-router';
import { CreditNoteNew, type CreditNoteNewSearch } from '../../../../features/sales-invoicing/CreditNoteNew';

/** Owned by G23. Create a credit note (BUILD_SPEC.md §8.4 step 5) — reached either
 * with `?invoiceId=` (from an invoice's "Create credit note" button) or bare (user
 * picks a creditable invoice here). `CreditNoteNewSearch` is exported from the
 * feature module per this goal's S0 instruction (an unexported `validateSearch`
 * interface fails typecheck with TS4023). */
export const Route = createFileRoute('/_authenticated/sales-invoicing/credit-notes/new')({
  validateSearch: (search: Record<string, unknown>): CreditNoteNewSearch => ({
    invoiceId: typeof search.invoiceId === 'string' ? search.invoiceId : undefined,
  }),
  component: CreditNoteNewPage,
});

function CreditNoteNewPage() {
  const { invoiceId } = Route.useSearch();
  return <CreditNoteNew preselectedInvoiceId={invoiceId} />;
}
